import { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { translations } from "../translations";
import { getLangFromPath, SUPPORTED_LANGUAGES } from "../i18nConfig";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const location = useLocation();

  const [lang, setLang] = useState(() => getLangFromPath(window.location.pathname));

  // Sync language from URL on every navigation
  useEffect(() => {
    const detected = getLangFromPath(location.pathname);
    setLang(detected);
  }, [location.pathname]);

  const t = translations[lang] || translations.en;

  const langConfig = SUPPORTED_LANGUAGES.find((l) => l.code === lang) || SUPPORTED_LANGUAGES[0];

  useEffect(() => {
    document.documentElement.lang = lang === "pt" ? "pt-BR" : lang;
    document.documentElement.dir = langConfig.dir;
  }, [lang, langConfig.dir]);

  return (
    <LanguageContext.Provider value={{ lang, t, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
  return ctx;
};
